import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  TuiTextfieldControllerModule,
  TuiInputModule,
  TuiInputDateModule,
  TuiInputNumberModule,
  TuiMultiSelectModule,
  TuiSelectModule,
} from '@taiga-ui/legacy';
import { TuiDataList, TuiLoader, TuiButton } from '@taiga-ui/core';
import { TuiAutoFocus, TuiLet } from '@taiga-ui/cdk';
import { NgxPermissionsModule } from 'ngx-permissions';
import { FieldModule } from '@src/app/shared/field';
import { SharedModule } from '@src/app/shared';
import { PhotoModule } from '@src/app/modules/photo';
import { ContactsModule } from '@src/app/modules/contacts';
import { InputFilesModule } from '@src/app/modules/input-files';

import { OrganisationInfoComponent } from './organisation-info.component';
import { OrganisationInfoViewComponent } from './organisation-info-view/organisation-info-view.component';
import { OrganisationInfoEditComponent } from './organisation-info-edit/organisation-info-edit.component';

@NgModule({
  declarations: [OrganisationInfoComponent, OrganisationInfoViewComponent, OrganisationInfoEditComponent],
  imports: [
    CommonModule,
    FieldModule,
    FormsModule,
    NgxPermissionsModule,
    PhotoModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    TuiAutoFocus,
    TuiButton,
    ...TuiDataList,
    TuiInputModule,
    TuiInputDateModule,
    TuiInputNumberModule,
    TuiLet,
    TuiLoader,
    TuiMultiSelectModule,
    TuiSelectModule,
    TuiTextfieldControllerModule,
    ContactsModule,
    InputFilesModule,
  ],
  exports: [OrganisationInfoComponent],
})
export class OrganisationInfoModule {}
